import { TalesFood } from "../../../utils/types/TalesFood";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { db, storage } from "../../../firebase/config";
import firebase from "firebase";
import FieldValue = firebase.firestore.FieldValue;

export const addFood = createAsyncThunk("food/add", async (food: TalesFood) => {
  try {
    const file = food.file;
    let fileDownloadUrl;
    if (file) {
      const storageRef = storage.ref("food");
      const prova = await storageRef
        .child(file.name ?? "logo_image.jpg")
        .put(file);
      fileDownloadUrl = await prova.ref.getDownloadURL();
    }

    return db.collection("food").add({
      ...food,
      logoUrl: fileDownloadUrl,
      file: null,
      show: `${food.show}` === "true",
      creationDate: FieldValue.serverTimestamp(),
    });
  } catch (e: any) {
    console.log(e);

    return Promise.reject(`Food non aggiunto, ${e.message}`);
  }
});
